import { adminHttpClient } from '../../commons/adminHttpClient'
import { BenefitProductClassResponse } from './getBenefitProductClasses'

const getUserBenefitProductClass = (): Promise<BenefitProductClassResponse> => {
  return adminHttpClient.get(`/Benefit/UserProductClassHraDetails`)
}

export default getUserBenefitProductClass
